import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";
import {lastValueFrom, Observable} from "rxjs";
import {FormModel} from "../forms/models/constants";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UserService {

    url = "/api/users/protected";


    constructor(
        private http: HttpClient,
        private cookieService: CookieService
    ) {
    }

    getLoggedInUser(): Observable<any> {
        return this.http.get(this.url + "/loggedin");
    }

    getCurrentUser() {
        return lastValueFrom(this.getLoggedInUser());
    }

    putDeleteRequest() {
        return this.http.patch(this.url + "/delete-request", null);
    }

    deleteConfirm(otp: string) {
        return this.http.delete(this.url + "/delete-confirm/"+ otp);
    }

    logOut(id: string) {
        const url = "/rest/logout";
        return this.http.post(url, id);
    }


    getUsersAsFormModel(): Observable<FormModel[]> {
        const url = `${this.url}/members`;

        return this.http.get<any[]>(url).pipe(
            map((apiData) => {
                // Map each user object from API response to FormModel
                return apiData.map((user) => ({
                    id: user.id,
                    label: `${user.firstname} ${user.lastname}`,
                    value: user.id,
                    // Optional required field if you need it; otherwise, remove
                    required: false
                }));
            })
        );


    }
}
